<style lang="scss">
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/mixins";

  button {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    margin-left: auto;
    padding: 0;
    justify-content: center;
    @include colors.color(black_50);

    &:hover {
      @include colors.color(primary_50);
    }

    &:focus {
      @include colors.color(primary_60);
    }
  }
</style>

<script>
  import { getContext, onDestroy } from "svelte";
  import IconScale from "../../atoms/IconScale.svelte";
  import { TABLE_STORES } from "./table-context";

  let cls = "";
  let click = () => {};
  export { cls as class, click as onclick };
  export let dataRowId;

  const { expandButtonStateStore } = getContext(TABLE_STORES);
  const wrappedClick = (e) => {
    $expandButtonStateStore[dataRowId] = !$expandButtonStateStore[dataRowId];
    e.stopPropagation();
    return click(e);
  };

  onDestroy(() => {
    $expandButtonStateStore[dataRowId] = false;
  });
</script>

<button class={cls} on:click={wrappedClick}>
  <IconScale
    backgroundColor="transparent"
    color="black_90"
    class="fa-regular {$expandButtonStateStore[dataRowId]
      ? 'fa-chevron-up'
      : 'fa-chevron-down'}"
    size="medium"
  />
</button>
